var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-admin layout-component-main"},[_c('div',{staticClass:"breadcrumbs"},[_vm._t("breadcrumbs")],2),_vm._v(" "),_c('div',{staticClass:"header"},[_c('h1',[_vm._t("header")],2)]),_vm._v(" "),_c('div',{staticClass:"body"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47cb6286","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/LayoutAdminBasic.vue
// module id = null
// module chunks = 